export default __webpack_public_path__ + "static/CBX-Mapa-Parking-MAY2023-solo-nombres-ISOMETRICO-completo-ESP-fa0a343eea6610adc2bff19ca6cf3e61.png";